import React from 'react';
import Select from 'react-select';
function CopyFromLastVisitDropDown({
  dataArr = [],
  selectedVal = '',
  calback = () => {},
}) {
  // Assuming allData is an array of objects with required properties
  const options = dataArr?.lastVisArr?.map((data) => ({
    value: `${data?.soapId}_${data?.appointment_id}_${data?.visitId}`,
    label: data?.nodata
      ? `${data?.consultDate}\n${data?.resName.substr(0, 6)}...\n${
          data?.typeOfVisit
        }\n${data?.nodata}`
      : `${data?.consultDate}\n${data?.resName.substr(0, 6)}...\n${
          data?.typeOfVisit
        }`,
    isDisabled: data?.nodata,
  }));

  return (
    <Select
      className="react-select-container width100"
      value={selectedVal || ''}
      onChange={calback}
      options={options}
      isMulti={false}
      isClearable={true}
      classNamePrefix="react-select"
      //   components={{
      //     Option: CustomOption, // If you want to customize the appearance of each option
      //   }}
    />
  );
}

export default CopyFromLastVisitDropDown;
